"use client";
import { useEffect, useState } from "react";

// Plain fetch (not apiFetch) so a 401 here, e.g. on /login, doesn't trigger the
// app-wide sign-out redirect; the bar simply stays hidden in that case.
export default function SaleApiStatusBar() {
  const [environment, setEnvironment] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    fetch(`/api/api-proxy?path=${encodeURIComponent("/api/sale-api-environment")}`, { signal: controller.signal })
      .then(res => (res.ok ? res.json() : null))
      .then(data => setEnvironment(data?.environment ?? null))
      .catch(() => setEnvironment(null));
    return () => controller.abort();
  }, []);

  if (!environment) return null;

  const isProduction = environment === "PRODUCTION";
  const label = isProduction ? "USING PRODUCTION API" : environment === "DEVELOPMENT" ? "USING DEVELOPMENT API" : "USING UNKNOWN API";
  const background = environment === "DEVELOPMENT" ? "#28a745" : "#dc3545";
  const title = isProduction ? "TELL CJ TO SWITCH IT TO DEV!" : environment === "DEVELOPMENT" ? "😎" : "SOMETHING IS WRONG, TELL CJ";


  return (
    <div className="text-white text-center" style={{ background }} title={title}>
      <strong>{label}</strong>
    </div>
  );
}
